"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.computeForceClose = exports.computeLiquidation = exports.computeForceCloseByPair = void 0;
const ethers_1 = require("ethers");
const lodash_1 = __importDefault(require("lodash"));
const logger_1 = require("../logger");
const calls_1 = require("../multicall/calls");
const utils_1 = require("../utils");
const gql_1 = require("./gql");
function sortingPerpetualsToDistTargetHedgeFunc(a, b) {
    var _a, _b, _c, _d, _e, _f;
    if (((_a = a.distToTargetHedge) === null || _a === void 0 ? void 0 : _a.lte(ethers_1.BigNumber.from(0))) && ((_b = b.distToTargetHedge) === null || _b === void 0 ? void 0 : _b.lte(ethers_1.BigNumber.from(0)))) {
        return a.distToTargetHedge.gt(b.distToTargetHedge) ? -1 : 1;
    }
    else if (((_c = a.distToTargetHedge) === null || _c === void 0 ? void 0 : _c.gt(ethers_1.BigNumber.from(0))) && ((_d = b.distToTargetHedge) === null || _d === void 0 ? void 0 : _d.gt(ethers_1.BigNumber.from(0)))) {
        return a.distToTargetHedge.gt(b.distToTargetHedge) ? 1 : -1;
    }
    else if (((_e = a.distToTargetHedge) === null || _e === void 0 ? void 0 : _e.lte(ethers_1.BigNumber.from(0))) && ((_f = b.distToTargetHedge) === null || _f === void 0 ? void 0 : _f.gt(ethers_1.BigNumber.from(0)))) {
        return -1;
    }
    else {
        return 1;
    }
}
function sortPerpetualsByDistTargetHedge(perpetuals) {
    return lodash_1.default.cloneDeep(perpetuals).sort(sortingPerpetualsToDistTargetHedgeFunc);
}
const computeLiquidationByPair = (pair, perpetuals) => {
    const { requireForceClose, targetHedgeAmount } = pair.computeRequireForceClose();
    let totalHedgeAmountAfterClose = pair.totalHedgeAmount;
    const liquidables = perpetuals.reduce((_liquidables, perpetual) => {
        const isLiquidable = pair === null || pair === void 0 ? void 0 : pair.lowerExchangeRate.lt(perpetual.liquidationPrice);
        if (isLiquidable) {
            _liquidables.push(perpetual.perpetualId);
            totalHedgeAmountAfterClose = totalHedgeAmountAfterClose.sub(perpetual.coveredAmount);
        }
        return _liquidables;
    }, []);
    return { liquidables, requireForceClose, totalHedgeAmountAfterClose, targetHedgeAmount };
};
const computeForceCloseByPair = (pair, perpetuals) => {
    const { requireForceClose, targetHedgeAmount } = pair.computeRequireForceClose();
    const forceClosables = [];
    let totalHedgeAmountAfterClose = pair.totalHedgeAmount;
    const now = Date.now();
    let curDistanceToTarget = totalHedgeAmountAfterClose.sub(targetHedgeAmount);
    let perpetualsWithDistToTargetHedge = perpetuals.map((perp) => {
        perp.distToTargetHedge = curDistanceToTarget === null || curDistanceToTarget === void 0 ? void 0 : curDistanceToTarget.sub(perp.coveredAmount);
        return perp;
    });
    if (requireForceClose && totalHedgeAmountAfterClose.gt(targetHedgeAmount)) {
        (0, logger_1.Logger)('requireForceClose', `${pair.stable.symbol}/${pair.collateral.symbol}`);
        perpetualsWithDistToTargetHedge = sortPerpetualsByDistTargetHedge(perpetualsWithDistToTargetHedge);
        while (perpetualsWithDistToTargetHedge.length > 0) {
            const closestPerpetual = perpetualsWithDistToTargetHedge[0];
            if (now - closestPerpetual.lastUpdated >= pair.lockTime) {
                totalHedgeAmountAfterClose = totalHedgeAmountAfterClose === null || totalHedgeAmountAfterClose === void 0 ? void 0 : totalHedgeAmountAfterClose.sub(closestPerpetual.coveredAmount);
                forceClosables.push(closestPerpetual.perpetualId);
            }
            if (!requireForceClose || (totalHedgeAmountAfterClose === null || totalHedgeAmountAfterClose === void 0 ? void 0 : totalHedgeAmountAfterClose.lte(targetHedgeAmount))) {
                break;
            }
            perpetualsWithDistToTargetHedge.shift();
            curDistanceToTarget = totalHedgeAmountAfterClose === null || totalHedgeAmountAfterClose === void 0 ? void 0 : totalHedgeAmountAfterClose.sub(targetHedgeAmount);
            perpetualsWithDistToTargetHedge = perpetualsWithDistToTargetHedge.map((perp) => {
                const distToTargetHedge = curDistanceToTarget === null || curDistanceToTarget === void 0 ? void 0 : curDistanceToTarget.sub(perp.coveredAmount);
                perp.distToTargetHedge = distToTargetHedge;
                return perp;
            });
            perpetualsWithDistToTargetHedge = sortPerpetualsByDistTargetHedge(perpetualsWithDistToTargetHedge);
        }
    }
    return { forceClosables, requireForceClose, totalHedgeAmountAfterClose, targetHedgeAmount };
};
exports.computeForceCloseByPair = computeForceCloseByPair;
const setupPairs = (provider, chainId) => __awaiter(void 0, void 0, void 0, function* () {
    const { allPairs, calls } = (0, calls_1.getCalls)(chainId);
    const ALL_PAIRS = (0, utils_1.getAllPairNames)(chainId).reduce((acc, value) => {
        acc[value] = {
            name: value,
            perpetuals: [],
        };
        return acc;
    }, {});
    const before = Date.now();
    const [pairs, perpetuals] = yield Promise.all([(0, calls_1.fetchPairs)(calls, allPairs, provider, chainId), (0, gql_1.fetchPerpetuals)(chainId)]);
    (0, logger_1.Logger)(`fetchAll: ${Date.now() - before}ms`);
    for (const pair of pairs) {
        const pairName = `${pair.stable.symbol}/${pair.collateral.symbol}`;
        ALL_PAIRS[pairName].pairData = pair;
    }
    perpetuals.forEach((perp) => {
        const perpetual = (0, utils_1.convertTGPerpToPerpetual)(perp, chainId);
        const pairName = `${perpetual.stable.symbol}/${perpetual.collateral.symbol}`;
        ALL_PAIRS[pairName].perpetuals.push(perpetual);
    });
    return ALL_PAIRS;
});
const computeLiquidation = (provider, chainId) => __awaiter(void 0, void 0, void 0, function* () {
    const ALL_PAIRS = yield setupPairs(provider, chainId);
    const allLiquidables = {};
    for (const pairName in ALL_PAIRS) {
        const data = ALL_PAIRS[pairName];
        const { liquidables } = computeLiquidationByPair(data.pairData, data.perpetuals);
        (0, logger_1.Logger)(pairName, 'LIQUIDABLES:', liquidables);
        if (liquidables.length > 0) {
            allLiquidables[pairName] = [...liquidables];
        }
    }
    return { allLiquidables };
});
exports.computeLiquidation = computeLiquidation;
const computeForceClose = (provider, chainId) => __awaiter(void 0, void 0, void 0, function* () {
    const ALL_PAIRS = yield setupPairs(provider, chainId);
    const allForceClosables = {};
    for (const pairName in ALL_PAIRS) {
        const data = ALL_PAIRS[pairName];
        const { requireForceClose, targetHedgeAmount, totalHedgeAmountAfterClose, forceClosables } = (0, exports.computeForceCloseByPair)(data.pairData, data.perpetuals);
        ALL_PAIRS[pairName].pairComputedData = {
            requireForceClose,
            targetHedgeAmount,
            initialTotalHedgeAmount: data.pairData.totalHedgeAmount,
            totalHedgeAmountAfterClose,
        };
        (0, logger_1.Logger)(pairName, requireForceClose, targetHedgeAmount.toFixed(2), totalHedgeAmountAfterClose === null || totalHedgeAmountAfterClose === void 0 ? void 0 : totalHedgeAmountAfterClose.toFixed(2), forceClosables);
        if (forceClosables.length > 0) {
            allForceClosables[pairName] = [...forceClosables];
        }
    }
    return { allForceClosables };
});
exports.computeForceClose = computeForceClose;
//# sourceMappingURL=computeLiquidationForceClose.js.map